import { CommandType } from "~app/common/services/cqs/CommandType";
import { ProduktionsmallProduktinstruktionBaseCommand } from "./ProduktionsmallProduktinstruktionBaseCommand";

export class AddProduktionsmallProduktinstruktionCommand extends ProduktionsmallProduktinstruktionBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddProduktionsmallProduktinstruktionCommand";

    constructor(produktionsmallGuid: string, handelssortimentId: number, produktId: number, produktinstruktionId: number, medIUtbytessimulering: boolean) {
        super(AddProduktionsmallProduktinstruktionCommand.$type, CommandType.Insert);
        this.produktionsmallGuid = produktionsmallGuid;
        this.handelssortimentId = handelssortimentId;
        this.produktId = produktId;
        this.produktinstruktionId = produktinstruktionId;
        this.medIUtbytessimulering = medIUtbytessimulering;
    }
}
